import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import {
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaXTwitter,
  FaLinkedin
} from "react-icons/fa6";
import SEO from "../components/SEO";

const C = {
  bg: "#f8f9fd", dark: "#1a1a2e", gold: "#f5c518", goldD: "#d4a80f",
  gray: "#6b7280", grayL: "#9ca3af", border: "#e5e7eb", white: "#ffffff",
};
const F = { display: "'Playfair Display', serif", body: "'Plus Jakarta Sans', sans-serif" };

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800;900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

  @keyframes fadeUp  { from{opacity:0;transform:translateY(28px)} to{opacity:1;transform:translateY(0)} }
  @keyframes pulse   { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:.5;transform:scale(1.4)} }
  @keyframes spin    { to{transform:rotate(360deg)} }
  @keyframes checkPop{ 0%{transform:scale(0)} 70%{transform:scale(1.15)} 100%{transform:scale(1)} }

  *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
  body { font-family:'Plus Jakarta Sans',sans-serif; overflow-x:hidden; }

  .contact-input {
    width:100%;
    padding:14px 16px;
    border-radius:14px;
    border:1.5px solid #e5e7eb;
    font-size:14px;
    font-family:'Plus Jakarta Sans',sans-serif;
    color:#1a1a2e;
    background:#f8f9fd;
    outline:none;
    transition:border-color .2s, box-shadow .2s, background .2s;
  }
  .contact-input:focus {
    border-color:#f5c518;
    box-shadow:0 0 0 4px rgba(245,197,24,.12);
    background:#fffdf0;
  }
  .contact-input::placeholder { color:#9ca3af; }

  .contact-card {
    background:#fff;
    border-radius:20px;
    border:1.5px solid #e5e7eb;
    padding:22px 20px;
    box-shadow:0 4px 18px rgba(0,0,0,.06);
    transition:all .3s;
    text-decoration:none;
    display:block;
  }
  .contact-card:hover {
    border-color:#f5c518;
    transform:translateY(-6px);
    box-shadow:0 16px 40px rgba(245,197,24,.13);
  }

  .submit-btn:hover {
    transform:translateY(-2px) !important;
    box-shadow:0 12px 36px rgba(245,197,24,.5) !important;
  }
  .submit-btn:disabled {
    opacity:.65;
    cursor:not-allowed !important;
    transform:none !important;
  }

  @media(max-width:768px) {
    .hero-sec    { padding:52px 16px 40px !important; }
    .sec-pad     { padding:52px 16px !important; }
    .form-grid   { grid-template-columns:1fr !important; }
    .contact-grid{ grid-template-columns:1fr !important; }
    .page-grid   { grid-template-columns:1fr !important; }
    .hero-h1     { font-size:clamp(32px,8vw,52px) !important; }
  }
`;

const CONTACT_METHODS = [
  {
    icon: "📞",
    bg: "rgba(245,197,24,.1)",
    border: "rgba(245,197,24,.3)",
    label: "Call Us",
    value: "+91 92654 07669",
    sub: "Mon–Sun · 6 AM – 11 PM",
    href: "tel:+919265407669",
    cta: "Call Now",
    ctaBg: C,
  },
  {
    icon: "💬",
    bg: "rgba(37,211,102,.08)",
    border: "rgba(37,211,102,.25)",
    label: "WhatsApp",
    value: "+91 92654 07669",
    sub: "Quick replies in under 5 min",
    href: "https://wa.me/919265407669",
    cta: "Chat Now",
    ctaBg: "#25D366",
  },
  {
    icon: "✉️",
    bg: "rgba(59,130,246,.08)",
    border: "rgba(59,130,246,.25)",
    label: "Email",
    value: "halosorath@gmail.com",
    sub: "We respond within 24 hours",
    href: "mailto:halosorath@gmail.com",
    cta: "Send Email",
    ctaBg: "#3b82f6",
  },
  {
  icon: "📍",
  bg: "rgba(239,68,68,.08)",
  border: "rgba(239,68,68,.25)",
  label: "Office",
  value:
    "407, The Empire Complex, Vanthli Road",

  sub:
    "Near Petrol Pump, Madhuram, Junagadh - 362015",

  href:
    "https://maps.google.com/?q=407+The+Empire+Complex+Vanthli+Road+Madhuram+Junagadh+362015",

  cta: "View Map",

  ctaBg: "#ef4444",
},
];

const OFFICE_HOURS = [
  { day: "Monday – Friday", time: "6:00 AM – 11:00 PM" },
  { day: "Saturday",        time: "6:00 AM – 11:00 PM" },
  { day: "Sunday",          time: "7:00 AM – 10:00 PM" },
  { day: "Emergency Line",  time: "24 × 7 Available"    },
];

export default function ContactPage() {
  const [form, setForm]       = useState({ name: "", mobile: "", email: "", subject: "", message: "" });
  const [errors, setErrors]   = useState({});
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);
  const [submittedData, setSubmittedData] = useState(null);

  const set = (k, v) => { setForm(p => ({ ...p, [k]: v })); setErrors(p => ({ ...p, [k]: "" })); };

  const validate = () => {
    const e = {};
    if (!form.name.trim())                               e.name    = "Please enter your name";
    if (!/^\d{10}$/.test(form.mobile))                  e.mobile  = "Enter a valid 10-digit number";
    if (form.email && !/\S+@\S+\.\S+/.test(form.email)) e.email   = "Enter a valid email";
    if (!form.subject.trim())                            e.subject = "Please select a subject";
    if (!form.message.trim())                            e.message = "Please write your message";
    return e;
  };

  const handleSubmit = async (e) => {

  e.preventDefault();

  const errs = validate();

  if (Object.keys(errs).length) {

    setErrors(errs);

    return;
  }

  setLoading(true);

  try {

    const response = await fetch(
      "https://prashantbha.pythonanywhere.com/api/contact/",
      {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(form),
      }
    );

    const data = await response.json();

    if (data.success) {

  setSubmittedData(form);

  setSent(true);

  setForm({
    name: "",
    mobile: "",
    email: "",
    subject: "",
    message: "",
  });

} else {

      alert(data.error || "Failed to send");

    }

  } catch (error) {

    console.log(error);

    alert("Server Error");

  }

  setLoading(false);
};

  const SUBJECTS = ["General Enquiry", "Booking Help", "Pricing / Quote", "Driver Registration", "Corporate Partnership", "Complaint / Feedback", "Other"];

  return (
    <>
    <SEO page="contact" />
      <style>{CSS}</style>
      <div style={{ fontFamily: F.body, background: C.bg, color: C.dark, overflowX: "hidden" }}>
        <Header defaultActive="Contact" />

        {/* ── HERO ── */}
        <div className="hero-sec" style={{ background: "linear-gradient(150deg,#f8f9fd 0%,#fffbea 55%,#f8f9fd 100%)", padding: "72px 24px 56px", textAlign: "center", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", top: -60, right: -60, width: 280, height: 280, borderRadius: "50%", background: "rgba(245,197,24,.07)", pointerEvents: "none" }} />
          <div style={{ position: "absolute", bottom: -40, left: -40, width: 200, height: 200, borderRadius: "50%", background: "rgba(26,26,46,.04)", pointerEvents: "none" }} />

          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(245,197,24,.1)", border: "1px solid rgba(245,197,24,.3)", borderRadius: 50, padding: "6px 16px", fontSize: 11, color: "#b8860b", fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase", marginBottom: 20 }}>
            <span style={{ width: 6, height: 6, background: C.gold, borderRadius: "50%", animation: "pulse 1.8s ease-in-out infinite" }} />
            Always Here for You
          </div>

          <h1 className="hero-h1" style={{ fontFamily: F.display, fontSize: "clamp(36px,6vw,68px)", fontWeight: 900, color: C.dark, letterSpacing: "-2px", lineHeight: 1.1, marginBottom: 16, animation: "fadeUp .7s ease both" }}>
            Get in Touch<br /><span style={{ color: C.gold }}>We're Listening</span>
          </h1>
          <p style={{ fontSize: "clamp(14px,1.8vw,17px)", color: C.gray, maxWidth: 480, margin: "0 auto 28px", lineHeight: 1.7 }}>
            Have a question, need a quote, or want to partner with us? Reach out — our team responds faster than you'd expect.
          </p>
          <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
            {["Avg reply in 5 min", "No bots — real humans", "24×7 Emergency support"].map(t => (
              <span key={t} style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 12, fontWeight: 600, background: "rgba(26,26,46,.06)", borderRadius: 50, padding: "6px 14px", color: C.dark }}>
                <span style={{ color: "#22c55e", fontWeight: 700 }}>✔</span> {t}
              </span>
            ))}
          </div>
        </div>

        {/* ── CONTACT METHODS ── */}
        <section className="sec-pad" style={{ padding: "72px 24px 60px" }}>
          <div style={{ maxWidth: 1000, margin: "0 auto" }}>
            <div className="contact-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))", gap: 16, marginBottom: 64 }}>
              {CONTACT_METHODS.map((m, i) => (
                <a key={i} href={m.href} target={m.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="contact-card">
                  <div style={{ width: 50, height: 50, borderRadius: 14, background: m.bg, border: `1.5px solid ${m.border}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24, marginBottom: 14 }}>{m.icon}</div>
                  <div style={{ fontSize: 10, fontWeight: 700, color: C.grayL, letterSpacing: "1.5px", textTransform: "uppercase", marginBottom: 5 }}>{m.label}</div>
                  <div style={{ fontFamily: F.display, fontSize: "clamp(13px,2vw,16px)", fontWeight: 800, color: C.dark, marginBottom: 5 }}>{m.value}</div>
                  <div style={{ fontSize: 12, color: C.grayL, marginBottom: 14 }}>{m.sub}</div>
                  <div style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 12, fontWeight: 700, color: "#b8860b" }}>
                    {m.cta} <span>→</span>
                  </div>
                </a>
              ))}
            </div>

            {/* ── MAIN CONTENT: Form + Info ── */}
            <div className="page-grid" style={{ display: "grid", gridTemplateColumns: "1fr 420px", gap: 28, alignItems: "start" }}>

              {/* Contact Form */}
              <div style={{ background: C.white, borderRadius: 24, border: `1.5px solid ${C.border}`, padding: "36px 32px", boxShadow: "0 8px 32px rgba(0,0,0,.07)" }}>
                {sent ? (
                  <div style={{ textAlign: "center", padding: "48px 0" }}>
                    <div style={{ width: 72, height: 72, borderRadius: "50%", background: "linear-gradient(135deg,#f5c518,#d4a80f)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 34, margin: "0 auto 16px", animation: "checkPop .5s ease both" }}>🎉</div>
                    <h3 style={{ fontFamily: F.display, fontSize: 24, fontWeight: 800, color: C.dark, marginBottom: 8 }}>Message Sent!</h3>
                    <p style={{ fontSize: 14, color: C.gray, marginBottom: 24, lineHeight: 1.6 }}>Thanks, <strong>{submittedData?.name}</strong>!
We'll get back to you on
<strong> +91 {submittedData?.mobile} </strong>
 within a few minutes.</p>
                    <button onClick={() => { setSent(false); setForm({ name: "", mobile: "", email: "", subject: "", message: "" }); }}
                      style={{ background: `linear-gradient(135deg,${C.gold},${C.goldD})`, color: C.dark, border: "none", borderRadius: 50, padding: "12px 32px", fontSize: 14, fontWeight: 700, fontFamily: F.body, cursor: "pointer" }}>
                      Send Another Message
                    </button>
                  </div>
                ) : (
                  <>
                    <h2 style={{ fontFamily: F.display, fontSize: "clamp(20px,3vw,26px)", fontWeight: 800, color: C.dark, marginBottom: 6 }}>Send Us a Message</h2>
                    <p style={{ fontSize: 13, color: C.grayL, marginBottom: 28 }}>Fill in the form and we'll respond within minutes.</p>

                    <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                      <div className="form-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
                        {/* Name */}
                        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                          <label style={{ fontSize: 11, fontWeight: 700, color: C.dark, letterSpacing: "1px", textTransform: "uppercase" }}>👤 Full Name <span style={{ color: "#ef4444" }}>*</span></label>
                          <input className="contact-input" placeholder="e.g. Ravi Mehta" value={form.name} onChange={e => set("name", e.target.value)} />
                          {errors.name && <span style={{ fontSize: 11, color: "#ef4444", fontWeight: 600 }}>⚠ {errors.name}</span>}
                        </div>
                        {/* Mobile */}
                        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                          <label style={{ fontSize: 11, fontWeight: 700, color: C.dark, letterSpacing: "1px", textTransform: "uppercase" }}>📱 Mobile <span style={{ color: "#ef4444" }}>*</span></label>
                          <input className="contact-input" placeholder="10-digit number" value={form.mobile} maxLength={10} inputMode="numeric" onChange={e => set("mobile", e.target.value.replace(/\D/g, ""))} />
                          {errors.mobile && <span style={{ fontSize: 11, color: "#ef4444", fontWeight: 600 }}>⚠ {errors.mobile}</span>}
                        </div>
                      </div>

                      {/* Email */}
                      <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                        <label style={{ fontSize: 11, fontWeight: 700, color: C.dark, letterSpacing: "1px", textTransform: "uppercase" }}>✉️ Email (Optional)</label>
                        <input className="contact-input" type="email" placeholder="you@example.com" value={form.email} onChange={e => set("email", e.target.value)} />
                        {errors.email && <span style={{ fontSize: 11, color: "#ef4444", fontWeight: 600 }}>⚠ {errors.email}</span>}
                      </div>

                      {/* Subject */}
                      <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                        <label style={{ fontSize: 11, fontWeight: 700, color: C.dark, letterSpacing: "1px", textTransform: "uppercase" }}>📋 Subject <span style={{ color: "#ef4444" }}>*</span></label>
                        <select className="contact-input" value={form.subject} onChange={e => set("subject", e.target.value)} style={{ cursor: "pointer" }}>
                          <option value="">Select a topic...</option>
                          {SUBJECTS.map(s => <option key={s} value={s}>{s}</option>)}
                        </select>
                        {errors.subject && <span style={{ fontSize: 11, color: "#ef4444", fontWeight: 600 }}>⚠ {errors.subject}</span>}
                      </div>

                      {/* Message */}
                      <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                        <label style={{ fontSize: 11, fontWeight: 700, color: C.dark, letterSpacing: "1px", textTransform: "uppercase" }}>💬 Your Message <span style={{ color: "#ef4444" }}>*</span></label>
                        <textarea className="contact-input" rows={5} placeholder="Tell us how we can help you..." value={form.message} onChange={e => set("message", e.target.value)} style={{ resize: "vertical", lineHeight: 1.6 }} />
                        {errors.message && <span style={{ fontSize: 11, color: "#ef4444", fontWeight: 600 }}>⚠ {errors.message}</span>}
                      </div>

                      <button type="submit" disabled={loading} className="submit-btn"
                        style={{ background: `linear-gradient(135deg,${C.gold},${C.goldD})`, color: C.dark, border: "none", borderRadius: 50, padding: "15px", fontSize: 15, fontWeight: 800, fontFamily: F.display, cursor: "pointer", boxShadow: "0 6px 28px rgba(245,197,24,.35)", transition: "all .25s", display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
                        {loading
                          ? <><span style={{ display: "inline-block", width: 18, height: 18, border: "2.5px solid rgba(26,26,46,.3)", borderTopColor: C.dark, borderRadius: "50%", animation: "spin .7s linear infinite" }} />Sending…</>
                          : "📨 Send Message"
                        }
                      </button>
                    </form>
                  </>
                )}
              </div>

              {/* Right info column */}
              <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>

                {/* Office hours */}
                <div style={{ background: C.white, borderRadius: 20, border: `1.5px solid ${C.border}`, padding: "24px 22px", boxShadow: "0 4px 16px rgba(0,0,0,.06)" }}>
                  <h3 style={{ fontFamily: F.display, fontSize: 18, fontWeight: 800, color: C.dark, marginBottom: 18, display: "flex", alignItems: "center", gap: 8 }}>
                    <span style={{ width: 36, height: 36, borderRadius: 10, background: "rgba(245,197,24,.1)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>🕐</span>
                    Office Hours
                  </h3>
                  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    {OFFICE_HOURS.map((o, i) => (
                      <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 12px", borderRadius: 10, background: i === 3 ? "rgba(245,197,24,.07)" : "#f8f9fd", border: `1px solid ${i === 3 ? "rgba(245,197,24,.2)" : C.border}` }}>
                        <span style={{ fontSize: 13, fontWeight: 600, color: C.dark }}>{o.day}</span>
                        <span style={{ fontSize: 12, color: i === 3 ? C.goldD : C.gray, fontWeight: i === 3 ? 700 : 500 }}>{o.time}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Quick actions */}
                <div style={{ background: `linear-gradient(135deg,${C.dark},#2d3a6b)`, borderRadius: 20, padding: "24px 22px" }}>
                  <h3 style={{ fontFamily: F.display, fontSize: 17, fontWeight: 800, color: C.white, marginBottom: 6 }}>Need a Cab Right Now?</h3>
                  <p style={{ fontSize: 13, color: "rgba(255,255,255,.6)", marginBottom: 18, lineHeight: 1.6 }}>Skip the form — call or WhatsApp us directly for instant booking.</p>
                  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    <a href="tel:+919265407669" style={{ textDecoration: "none" }}>
                      <button style={{ width: "100%", background: `linear-gradient(135deg,${C.gold},${C.goldD})`, color: C.dark, border: "none", borderRadius: 14, padding: "13px 20px", fontSize: 14, fontWeight: 700, fontFamily: F.body, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                        📞 Call +91 92654 07669
                      </button>
                    </a>
                    <a href="https://wa.me/919265407669" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                      <button style={{ width: "100%", background: "#25D366", color: "#fff", border: "none", borderRadius: 14, padding: "13px 20px", fontSize: 14, fontWeight: 700, fontFamily: F.body, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                        <FaWhatsapp size={17} /> WhatsApp Us Now
                      </button>
                    </a>
                  </div>
                </div>

                {/* Social */}
                {/* Social */}
<div
  style={{
    background: C.white,
    borderRadius: 20,
    border: `1.5px solid ${C.border}`,
    padding: "20px 22px",
    boxShadow: "0 4px 16px rgba(0,0,0,.06)"
  }}
>
  <h3
    style={{
      fontFamily: F.display,
      fontSize: 16,
      fontWeight: 800,
      color: C.dark,
      marginBottom: 14
    }}
  >
    Follow HaloSorath
  </h3>

  <div style={{ display: "flex", gap: 10 }}>

    {
    
    [
  {
    icon: <FaFacebookF />,
    label: "Facebook",
    color: "#1877F2",
    link: "https://www.facebook.com/profile.php?id=61590337595706"
  },

  {
    icon: <FaInstagram />,
    label: "Instagram",
    color: "#E4405F",
    link: "https://www.instagram.com/halosorath/?theme=dark"
  },

  {
    icon: <FaYoutube />,
    label: "YouTube",
    color: "#FF0000",
    link: "https://www.youtube.com/@HaloSorath-CabServices"
  }
].map((item) => (

      <a
        key={item.label}
        href={item.link}
        target="_blank"
        rel="noreferrer"
        style={{
          textDecoration: "none",
          flex: 1
        }}
      >

        <div
          style={{
            background: "#f8f9fd",
            border: `1px solid ${C.border}`,
            borderRadius: 12,
            padding: "10px 6px",
            textAlign: "center",
            cursor: "pointer",
            transition: "all .2s"
          }}

          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = C.gold;
            e.currentTarget.style.background =
              "rgba(245,197,24,.07)";
          }}

          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor =
              C.border;

            e.currentTarget.style.background =
              "#f8f9fd";
          }}
        >

          <div
            style={{
              fontSize: 20,
              color: item.color,
              display: "flex",
              justifyContent: "center"
            }}
          >
            {item.icon}
          </div>

          <div
            style={{
              fontSize: 10,
              color: C.grayL,
              marginTop: 4
            }}
          >
            {item.label}
          </div>

        </div>

      </a>
    ))}

  </div>
</div>
              </div>
            </div>
          </div>
        </section>

        {/* ── MAP PLACEHOLDER ── */}
        <section style={{ padding: "0 24px 72px" }}>
          <div style={{ maxWidth: 1000, margin: "0 auto" }}>
            <div style={{ borderRadius: 24, overflow: "hidden", border: `1.5px solid ${C.border}`, background: "linear-gradient(135deg,#1a1a2e,#2d3a6b)", height: 220, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 12, boxShadow: "0 8px 32px rgba(0,0,0,.1)" }}>
              <div style={{ fontSize: 40 }}>📍</div>
              <div style={{ fontFamily: F.display, fontSize: 20, fontWeight: 800, color: C.white }}>Gujarat, India</div>
              <p style={{ fontSize: 13, color: "rgba(255,255,255,.5)" }}>Serving all major cities in Saurashtra & Gujarat</p>
              <a href="https://maps.google.com/?q=Gujarat,India" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
                <button style={{ background: `linear-gradient(135deg,${C.gold},${C.goldD})`, color: C.dark, border: "none", borderRadius: 50, padding: "9px 22px", fontSize: 13, fontWeight: 700, fontFamily: F.body, cursor: "pointer", marginTop: 4 }}>
                  View on Google Maps →
                </button>
              </a>
            </div>
          </div>
        </section>

        <Footer />

        
      </div>
    </>
  );
}